(function () {
    "use strict";

    angular
        .module("app")
        .factory("PrototypeService", PrototypeService);

    function PrototypeService($http, $q, WebApiService) {

        var service = {
            isPrototypeNameExists: isPrototypeNameExists,
            createPrototypeSeasonal: createPrototypeSeasonal,
            updatePrototypeSeasonal: updatePrototypeSeasonal,
            deletePrototypeSeasonal: deletePrototypeSeasonal,
            getPrototypeDetails: getPrototypeDetails,
            getPrototypeSeasonalDetails: getPrototypeSeasonalDetails,
            getPrototypePatterns: getPrototypePatterns,
            getPrototypeBrief: getPrototypeBrief,
            getPrototypeCriticalPaths: getPrototypeCriticalPaths,
            getLaunchList: getLaunchList,
            getAgeCodeList: getAgeCodeList,
            getECNReasons: getECNReasons,
            getWidthList: getWidthList,
            getRegionList: getRegionList,
            getProductTypeList: getProductTypeList,
            isStockNumberExists: isStockNumberExists,
            isStockNumberValid: isStockNumberValid,
            updatePrototypeData: updatePrototypeData,
            multiSearchPrototypes: multiSearchPrototypes,
            searchPrototypes: searchPrototypes,
            exportPrototypes: exportPrototypes,
            getFactoryCodes: getFactoryCodes,
            getCountries: getCountries,
            getColors: getColors,
            getNRFColors: getNRFColors,
            getProductTypes: getProductTypes,
            getServiceFee: getServiceFee,
            getPrototypeStatuses: getPrototypeStatuses,
            getPrototypeSpecLock: getPrototypeSpecLock,
            getCostingCompleteCounts: getCostingCompleteCounts,
            buyReady: buyReady,
            getDivisions: getDivisions,
            uploadMassPrototypeDocument: uploadMassPrototypeDocument,
            getPrototypeBuyReadyCounts: getPrototypeBuyReadyCounts,
            relinkPrototype: relinkPrototype,
            FactoryTransferUpdate: FactoryTransferUpdate,
            DualSourceUpdate: DualSourceUpdate,
            GetOutsoleTechs: GetOutsoleTechs,
            getCollections: getCollections,
            canPrototypeShiftSeason: canPrototypeShiftSeason,
            getSeasonsForPrototypeShift: getSeasonsForPrototypeShift,
            runBuyReadyReport: runBuyReadyReport,
            runBuyReadyReportForSeason: runBuyReadyReportForSeason,
            buyReadyOverrides: buyReadyOverrides,
            buyReadyOverridesUpdate: buyReadyOverridesUpdate,
            getPrototypeSizeRanges: getPrototypeSizeRanges,
            getSalesRegions: getSalesRegions
        };

        return service;

        function canPrototypeShiftSeason(prototypeId) {
            return WebApiService.get("/api/Prototype/CanPrototypeShiftSeason?prototypeId=" + prototypeId);
        }

        function getSeasonsForPrototypeShift(prototypeSeasonalId) {
            return WebApiService.get("/api/Prototype/GetSeasonsForPrototypeShift?prototypeSeasonalId=" + prototypeSeasonalId);
        }

        function getDivisions(brandId) {
            return WebApiService.get("/api/Prototype/GetDivisions?BrandId=" + brandId);
        }

        function getCollections(brandId, searchText) {
            return WebApiService.get("/api/Prototype/GetCollections?brandId= " + (brandId ? brandId : "") + "&searchText=" + (searchText ? searchText : ""));
        }

        function isPrototypeNameExists(prototypeId, prototypeName, brandId, seasonId) {
            return WebApiService.get("/api/Prototype/IsPrototypeNameExists?PrototypeId=" + prototypeId + "&PrototypeName=" + prototypeName + "&BrandId=" + brandId + "&SeasonId=" + seasonId);
        }

        function createPrototypeSeasonal(prototypeData, prototypeSeasonalData, patternId, ignoreLoadingBar, sizeRangePresetId) {
            var data = { Prototype: prototypeData, PrototypeSeasonal: prototypeSeasonalData, PatternId: patternId, SizeRangePresetId: sizeRangePresetId };
            return WebApiService.postJson("/api/Prototype/CreatePrototypeSeasonal", data, "", ignoreLoadingBar);
        }

        function getPrototypeDetails(prototypeId) {
            return WebApiService.get("/api/Prototype/PrototypeDetails?PrototypeId=" + prototypeId);
        }

        function getPrototypeSeasonalDetails(prototypeSeasonalId, ignoreLoadingBar) {
            return WebApiService.get("/api/Prototype/PrototypeSeasonalDetails?PrototypeSeasonalId=" + prototypeSeasonalId);
        }

        function getPrototypePatterns(prototypeSeasonalId, ignoreLoader) {
            return WebApiService.get("/api/Prototype/PrototypePatterns?PrototypeSeasonalId=" + prototypeSeasonalId, '', '', ignoreLoader);
        }

        function getPrototypeBrief(prototypeSeasonalId) {
            return WebApiService.get("/api/Prototype/PrototypeBrief?PrototypeSeasonalId=" + prototypeSeasonalId);
        }

        function getPrototypeCriticalPaths(prototypeSeasonalId) {
            return WebApiService.get("/api/Prototype/PrototypeCriticalPaths?PrototypeSeasonalId=" + prototypeSeasonalId);
        }

        function getLaunchList(prototypeSeasonalId) {
            return WebApiService.get("/api/Prototype/LaunchList?PrototypeSeasonalId=" + prototypeSeasonalId, '', '', false);
        }

        function getServiceFee(sapBrandId, factNameKy) {
            return WebApiService.get("/api/Prototype/GetServiceFee?sapBrandId=" + sapBrandId + "&factNameKy=" + factNameKy);
        }

        function getECNReasons() {
            return WebApiService.get("/api/Prototype/GetECNReasons", '', '', false);
        }

        function isStockNumberExists(prototypeId, prototypeSeasonalId, seasonId, stockNumber, factoryKey) {
            return WebApiService.get("/api/Prototype/IsStockNumberExists?PrototypeId=" + prototypeId + "&PrototypeSeasonalId=" + prototypeSeasonalId + "&SeasonId=" + seasonId + "&StockNumber=" + stockNumber + "&FactoryKey=" + factoryKey);
        }

        function isStockNumberValid(stockNum) {
            const queryString = {
                stockNum: stockNum,
                _: (new Date()).getTime()
            };
            return WebApiService.get('/api/Prototype/IsStockNumberValid', queryString);
        }

        function getAgeCodeList() {
            return WebApiService.get("/api/Prototype/AgeCodeList", '', '', false);
        }

        function getWidthList() {
            return WebApiService.get("/api/Prototype/WidthList", '', '', false);
        }

        function getRegionList() {
            return WebApiService.get("/api/Prototype/RegionList", '', '', false);
        }

        function getProductTypeList(patternDevTypeId) {
            return WebApiService.get("/api/Prototype/ProductTypeList?patternDevTypeId=" + patternDevTypeId);
        }

        function updatePrototypeData(prototypeData, prototypeSeasonalData, specLogData, sizeRanges) {
            return WebApiService.postJson("/api/Prototype/UpdatePrototypeData",
                {
                    prototype: prototypeData,
                    prototypeSeasonal: prototypeSeasonalData,
                    specLog: specLogData,
                    sizeRanges: sizeRanges
                }, undefined, false);
        }

        function multiSearchPrototypes(searchObject) {

            return WebApiService.postJson("/api/Prototype/MultiSearchPrototypes", searchObject);
        }

        function searchPrototypes(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {
            searchObject.pageNumber = pageNumber;
            searchObject.pageSize = pageSize;
            searchObject.sortColumn = sortColumn;
            searchObject.sortDirection = sortDirection;

            return WebApiService.postJson("/api/Prototype/SearchPrototypes", searchObject);
        }

        function exportPrototypes(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {
            searchObject.pageNumber = pageNumber;
            searchObject.pageSize = pageSize;
            searchObject.sortColumn = sortColumn;
            searchObject.sortDirection = sortDirection;

            return WebApiService.postJson("/api/Prototype/ExportPrototypes", searchObject);
        }

        function getFactoryCodes() {
            return WebApiService.get("/api/Prototype/GetFactoryCodes");
        }

        function getCountries(searchText) {
            return WebApiService.get("/api/Prototype/GetCountries?searchText=" + (searchText ? searchText : ""));
        }

        function getColors(searchText) {
            return WebApiService.get("/api/Prototype/GetColors?searchText=" + (searchText ? searchText : ""));
        }

        function getNRFColors(searchText) {
            return WebApiService.get("/api/Prototype/GetNRFColors?searchText=" + (searchText ? searchText : ""));
        }

        function getProductTypes() {
            return WebApiService.get("/api/Prototype/GetProductTypes");
        }

        function getPrototypeStatuses(brandId, seasonId, filterUser, ignoreLoader) {
            return WebApiService.get("/api/Prototype/GetPrototypeStatuses?BrandId=" + brandId + "&SeasonId=" + seasonId + "&filterUser=" + filterUser, '', '', ignoreLoader);
        }

        function getPrototypeSpecLock(brandId, seasonId, filterUser, ignoreLoader) {
            return WebApiService.get("/api/Prototype/GetPrototypeSpecLock?BrandId=" + brandId + "&SeasonId=" + seasonId + "&filterUser=" + filterUser, '', '', ignoreLoader);
        }

        function getCostingCompleteCounts(brandId, seasonId, filterUser, ignoreLoader) {
            return WebApiService.get("/api/Prototype/GetCostingCompleteCounts?BrandId=" + brandId + "&SeasonId=" + seasonId + "&filterUser=" + filterUser, '', '', ignoreLoader);
        }

        function getPrototypeBuyReadyCounts(brandId, seasonId, filterUser, onlyNew, ignoreLoader) {
            return WebApiService.get("/api/Prototype/GetPrototypeBuyReadyCounts?BrandId=" + brandId + "&SeasonId=" + seasonId + "&filterUser=" + filterUser + "&onlyNew=" + onlyNew, '', '', ignoreLoader);
        }

        function buyReady(stockNumber, factoryNameKey) {
            return WebApiService.get("/api/Prototype/BuyReady?StockNumber=" + stockNumber + "&FactoryNameKey=" + factoryNameKey);
        }

        function uploadMassPrototypeDocument(file) {
            return WebApiService.postFile("/api/Prototype/UploadPrototypes", file);
        }

        function relinkPrototype(prototypeId, newPatternId, oldPatternId) {
            return WebApiService.postJson("/api/Prototype/RelinkPrototype?prototypeId=" + prototypeId + "&newPatternId=" + newPatternId + "&oldPatternId=" + oldPatternId, null, null, false);
        }

        function FactoryTransferUpdate(prototypeSeasonalId, factoryKey, ctryOfOrig, factoryName, factoryGroupKey, factoryGroupName, isTariffMitigation, copyBuyReady) {
            return WebApiService.get("/api/Prototype/FactoryTransferUpdate?" + "PrototypeSeasonalId=" + prototypeSeasonalId + "&factoryKey=" + factoryKey + "&CtryOfOrig=" + ctryOfOrig + "&FactoryName=" + factoryName + "&factoryGroupKey=" + factoryGroupKey + "&factoryGroupName=" + factoryGroupName + "&isTariffMitigation=" + isTariffMitigation + "&copyBuyReady=" + copyBuyReady, '', '', false);
        }

        function DualSourceUpdate(prototypeSeasonalId, factoryKey, ctryOfOrig, factoryName, userId, factoryGroupKey, factoryGroupName, isTariffMitigation, copyBuyReady) {
            return WebApiService.get("/api/Prototype/DualSourceUpdate?" + "PrototypeSeasonalId=" + prototypeSeasonalId + "&factoryKey=" + factoryKey + "&CtryOfOrig=" + ctryOfOrig + "&UserID=" + userId + "&FactoryName=" + factoryName + "&factoryGroupKey=" + factoryGroupKey + "&factoryGroupName=" + factoryGroupName + "&isTariffMitigation=" + isTariffMitigation + "&copyBuyReady=" + copyBuyReady, '', '', false);
        }

        function GetOutsoleTechs() {
            return WebApiService.get("/api/Prototype/GetOutsoleTechs", '', '', false);
        }

        function updatePrototypeSeasonal(prototypeSeasonalData) {
            return WebApiService.postJson('/api/Prototype/UpdatePrototypeSeasonal', prototypeSeasonalData);
        }

        function deletePrototypeSeasonal(prototypeSeasonalId) {
            return WebApiService.postJson('/api/Prototype/DeletePrototypeSeasonal?prototypeSeasonalId=' + prototypeSeasonalId);
        }

        function runBuyReadyReportForSeason(seasonId) {
            return WebApiService.get("/api/Prototype/RunBuyReadyReportForSeason?SeasonID=" + seasonId);
        }

        function runBuyReadyReport(stockNumber, factoryKey, prototypeID, executeBuyReady) {
            return WebApiService.get("/api/Prototype/RunBuyReadyReport?StockNumber=" + stockNumber + "&FactoryKey=" + factoryKey + "&PrototypeSeasonalId=" + prototypeID + "&ExecuteBuyReady=" + executeBuyReady);
        }

        function buyReadyOverrides(stockNumber, factoryKey, searchString) {
            return WebApiService.get("/api/Prototype/BuyReadyOverrides?StockNumber=" + stockNumber + "&FactoryKey=" + factoryKey + '&SearchString=' + searchString);
        }

        function buyReadyOverridesUpdate(id, stockNumber, factoryKey, buyReady) {
            return WebApiService.get("/api/Prototype/BuyReadyOverridesUpdate?Id=" + id + "&StockNumber=" + stockNumber + "&FactoryKey=" + factoryKey + "&BuyReady=" + buyReady);
        }

        function getPrototypeSizeRanges(prototypeSeasonalId) {
            return WebApiService.get("/api/Prototype/GetPrototypeSizeRanges?prototypeSeasonalId=" + prototypeSeasonalId);
        }

        function getSalesRegions() {
            return WebApiService.get("/api/Prototype/SalesRegions");
        }
    }
})();
